<template>
  <div id="listWidget" class="mb-4">
    <div>
      <h4 class="mb-3">온도조절기 등록</h4>
      <p class="mb-0">
        1. 온도조절기를 포함시킬 방을 선택해주세요.
      </p>
      <p class="mb-0">
        2. 등록 버튼을 클릭해주세요.
      </p>
    </div>

    <hr class="mb-3" />

    <div class="row" v-if="groups.length > 0">
      <div class="col-xl-6 mb-3">
        <div class="text-muted fs-12px mb-2"><b>방 선택</b></div>
        <div class="list-group" style="border-radius: 1.2rem">
          <ListGroupItem
            style="border-radius: 1.2rem; margin-bottom: 4px;"
            v-for="(group, index) in groups"
            :key="group._id"
          >
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                :id="`gridCheck${index}`"
                :value="group._id"
                @change="onSelectGroupChange"
                :checked="selectedGroup == group._id"
                :disabled="!group.enable"
              />
              <label class="form-check-label" :for="`gridCheck${index}`">
                {{ group.name }}
              </label>
            </div>
          </ListGroupItem>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col" />
      <div class="col" />
      <div class="col">
        <button
          type="button"
          class="btn btn-primary btn-lg"
          style="width: 100%"
          @click="onRegistDeviceClick"
        >
          등록
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  reactive,
  getCurrentInstance,
  onBeforeMount,
  computed,
  onMounted,
  onBeforeUnmount,
  watch,
} from 'vue';
import { useStore } from 'vuex';
import Axios, { DeviceApi, GroupApi, ZoneApi } from '@/api';
import { useRouter, useRoute ,onBeforeRouteLeave, onBeforeRouteUpdate } from 'vue-router';
import PopDialog from '@/common/components/popup/PopDialog.vue';
import useModal from '@/common/hooks/useModal';
import ListGroupItem from '@/common/components/widgets/ListGroupItem.vue';
import { Template, DeviceType } from '@/common/constants';
import useMqttControl from '@/common/hooks/useMqttControl';

const mqttControl = reactive(useMqttControl());
const { emitter } = getCurrentInstance().appContext.config.globalProperties;
const props = defineProps(['handleNextStep', 'serial']);
const router = useRouter();
const route = useRoute();
const store = useStore();
const zone = computed(() => store.getters['home/getCurrentZone']);
const groups = computed(() => {
  return zone.value?.groups?.map((group) => {
    const boilerDevice = group.devices.find(device => device.type == 2);
    return {
      ...group,
      enable: boilerDevice ? false : true
    };
  }) || [];
});
console.log(JSON.stringify(groups.value))
const selectedGroup = ref(undefined);

const onSelectGroupChange = (e) => {
  if (e.target.checked) {
    selectedGroup.value = e.target.value;
  } else {
    selectedGroup.value = undefined;
  }
}

const onRegistDeviceClick = () => {
  if (!selectedGroup.value) {
    emitter.emit('showPopAlert', {
      description: '온도조절기를 포함할 방을 선택해주세요.',
    });
    return;
  }

  const targetGroup = groups.value.find(group => group._id == selectedGroup.value);
  if (!targetGroup.enable) {
    emitter.emit('showPopAlert', {
      description: '이미 온도조절기가 포함된 방입니다.\n다른 방을 선택해주세요.',
    });
    return;
  }

  const controllerId = props.serial.slice(0, props.serial.indexOf("-"));
  emitter.emit('setLoadingText', '온도조절기를 등록하고 있습니다.');
  // model에 QR 시리얼을 넣지 않음 → 서버가 tempController(MQTT Version의 T02 등)로 설정
  requestAddController({
    zoneId: zone.value._id,
    controller: {
      _id: controllerId,
      version: 1
    }
  });

}

const requestAddController = async (payload) => {
  try {
    const result = await Axios.post(
      ZoneApi.REGIST_ZONE_TEMP_CTRLS.replace(':id', payload.zoneId),
      payload.controller,
    );
    if (result.resultCode === '0000') {
      requestAddDevice({
        groupId: selectedGroup.value,
        device: {
          controllerId: payload.controller._id,
          name: props.serial,
          type: DeviceType.Boiler
        }
      });
      return;
    }

    emitter.emit('showPopAlert', {
      description: result.resultMessage,
    });
  } catch (e) {
    console.log(e);
    emitter.emit('showPopAlert', {
      description: '장치 추가 중 오류가 발생하였습니다.',
    });
  }
};

const requestAddDevice = async (payload) => {
  try {
    const result = await Axios.post(
      GroupApi.REGIST_GROUP_DEVICES.replace(':id', payload.groupId),
      payload.device,
    );
    if (result.resultCode === '0000') {
      // store.commit('home/addDevice', {
      //   zoneId: parseInt(zone.value._id),
      //   groupId: parseInt(payload.groupId),
      //   data: result.resultData.device,
      // });
      props.handleNextStep();
      return;
    }

    emitter.emit('showPopAlert', {
      description: result.resultMessage,
    });
  } catch (e) {
    console.log(e);
    emitter.emit('showPopAlert', {
      description: '장치 추가 중 오류가 발생하였습니다.',
    });
  }
};
</script>